// KPIs de la pestaña de referidos, contados sobre la misma lectura que usa su panel: la de una
// cadena o, con `retailerIds`, la suma de todas.
import { KpiBar } from '@/shared/patterns/KpiBar';
import type { ReferralChannel } from '../api/promotionsContract';
import { useReferralPromotionsByRetailer, useSalePromotions } from '../api/usePromotions';
import { mergeReferralLists, referralKpiItems } from '../lib/referralKpis';

export interface ReferralPromotionKpisProps {
    channel: ReferralChannel;
    /** El mismo que recibe `ReferralPromotionsPanel`, para compartir la lectura. */
    retailerId?: string;
    /** Las cadenas de quien abarca el silo; con ellas se suman las listas de todas. */
    retailerIds?: readonly string[];
    enabled: boolean;
    now: Date;
}

export function ReferralPromotionKpis({
    channel,
    retailerId,
    retailerIds,
    enabled,
    now,
}: ReferralPromotionKpisProps) {
    const multi = retailerIds !== undefined;
    const single = useSalePromotions({
        archived: false,
        enabled: enabled && !multi,
        kind: 'REFERRAL',
        channel,
        ...(retailerId ? { retailerId } : {}),
    });
    const byRetailer = useReferralPromotionsByRetailer({
        channel,
        retailerIds: retailerIds ?? [],
        enabled: enabled && multi,
    });
    const list = multi ? mergeReferralLists(byRetailer) : single;
    return <KpiBar items={referralKpiItems(list, enabled, now)} />;
}
